import Link from 'next/link'
import { RichText } from 'prismic-reactjs'
import { LinkResolver } from '../../utils/helper'


interface Props {
  links: Array<Link>,
}

interface Link {
  links__title: any,
  links__link: {
    href?: any,
  },
}

export const LinkTree: React.FunctionComponent<Props> = ({
  links
}) => {
  return (

      <ul className='linktree m-t--sm'>
        { links.map((link, key) => {
          return (
            <li
              key={ key }
              className='linktree__link'
            >
              {/* @ts-ignore */}
              <Link href={ link.links__link.url }>
                <a
                  target='_blank'
                  rel='noopener'
                >
                  { RichText.asText(link.links__title) }
                </a>
              </Link>
            </li>
          )
        })}
      </ul>
  )
}
